// import styled from "styled-components";
import { styled as muiStyled } from "@mui/system";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";

const StyledDataGridToolbar = muiStyled(
  GridToolbarQuickFilter,
  {}
)(({ theme }) => ({
  "& .MuiInputBase-root": {
    paddingBottom: "0 !important",
    border: "2px",
    borderColor: "#AAAAAA",
    borderStyle: "solid",
    borderRadius: "2px",
    color: "#AAAAAA",
  },
  "& .MuiInput-root:before": {
    content: "none",
  },
  "& .MuiTextField-root": {
    paddingBottom: "0 !important",
  },
  paddingBottom: "0",
}));

export { StyledDataGridToolbar };
